import React, {Component} from 'react';
import {translate} from 'react-i18next';

class LoginForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: ''
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleFormSubmit(e) {
        e.preventDefault();
        if(!this.props.loading) {
            this.props.onLoginSubmit(this.state.username, this.state.password);
        }
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="m-t LoginForm">
                {this.props.error ? (
                    <div className="bg-warning p-xs m-b b-r-xs">
                        {t('login.error')}
                    </div>
                ) : null}
                {this.props.roleError ? (
                    <div className="bg-warning p-xs m-b b-r-xs">
                        {t('login.roleError')}
                    </div>
                ) : null}
                <form onSubmit={this.handleFormSubmit}>
                    <div className="form-group">
                        <input className="form-control" type="text" placeholder={t('login.username')} name="username" value={this.state.username} onChange={this.handleInputChange}/>
                    </div>
                    <div className="form-group">
                        <input className="form-control" type="password" placeholder={t('login.password')} name="password" value={this.state.password} onChange={this.handleInputChange}/>
                    </div>
                    <button className="btn btn-primary block full-width m-b" type="submit" disabled={this.props.loading}>
                        {this.props.loading ? (
                            <i className='fa fa-spinner fa-spin '/>
                        ) : null}
                        {t('login.submit')}
                    </button>
                </form>
            </div>
        )
    }
}

export default translate()(LoginForm);